import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  FormControl,
  Tooltip,
  Switch,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import ActionButton from "../../components/ActionButton";
import { taxServiceClient } from "../../AxiosClient";
import { useSelector } from "react-redux";
import SearchLanguages from "../../components/search/SearchLanguages";
import PropertyNames from "../../PropertyNames";
import { getSearchLanguages } from "../../utils/KpsUtils";

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: 15,
    display: "flex",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  setting: {
    marginBottom: 5,
  },
}));
function InterfaceSettings(props) {
  const [saving, setSaving] = useState(false);
  const appProperties = useSelector((state) => {
    return state.setting.applicationProperties;
  });
  const [settings, setSettings] = useState({
    disableInfiniteLists: false,
    searchLanguages: getSearchLanguages(props.currentUser, appProperties),
  });
  const { t } = useTranslation();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(
    () => {
      setSettings({
        ...props.currentUser.userSettings,
        searchLanguages: getSearchLanguages(props.currentUser, appProperties),
      });
    },
    [props.currentUser]
  );

  const save = () => {
    setSaving(true);
    taxServiceClient
      .patch(`/user/${props.currentUser.userId}`, {
        userSettings:settings, 
      })
      .then((res) => {
        props.updateUserState(res.data);
        enqueueSnackbar(t("user_updated_successfully"), {
          variant: "success",
        });
        setSaving(false);
      })
      .catch((err) => {
        enqueueSnackbar(t("error_updating_user"), {
          variant: "error",
        });
        setSaving(false);
      });
  };
  return (
    <>
      <div className={classes.header}>
        <Typography variant="h5" style={{ marginRight: 10 }}>
          {t("user_settings_interface_header")}
        </Typography>
        <ActionButton
          variant="contained"
          color="primary"
          onClick={save}
          loading={saving}
        >
          {t("global_save")}
        </ActionButton>
      </div>
      <div className={classes.content}>
        <div className={classes.setting}>
          <SearchLanguages
            value={settings.searchLanguages}
            onChange={(languages) =>
              setSettings({ ...settings, searchLanguages: languages })
            }
          />
          <FormHelperText>
            {t("default_search_languages_helper_text")}
          </FormHelperText>
        </div>
        <FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={settings.disableInfiniteLists}
                onChange={(e) =>
                  setSettings({
                    ...settings,
                    disableInfiniteLists: e.target.checked,
                  })
                }
                name="disableInfiniteLists"
                aria-describedby="disable-infinite-scroll-helper"
              />
            }
            label={t("interface_disable_infinite_scroll")}
          />
          <FormHelperText id="disable-infinite-scroll-helper">
            {t("interface_disable_infinite_scroll_helper_text")}
          </FormHelperText>
        </FormControl>
        <FormControl className={classes.formControl}>
          <FormControlLabel
            control={
              <Switch
                checked={!!settings.micAlwaysEnabled}
                onChange={(e) => {
                  setSettings({
                    ...settings,
                    micAlwaysEnabled: e.target.checked,
                  });
                }}
              />
            }
            label="Mic always enabled"
          />
          <FormHelperText id="mic-enabled-helper">
            Always enable the microphone rather than requiring a button press
          </FormHelperText>
        </FormControl>
      </div>
    </>
  );
}

export default InterfaceSettings;
